import { render, staticRenderFns } from "./BaseEditPage.vue?vue&type=template&id=1ac1ede8"
import script from "./BaseEditPage.vue?vue&type=script&lang=js"
export * from "./BaseEditPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports